import * as React from "react";
import { Dialog } from "@cmsgov/design-system-core";
import "./../styles/DataLoader.css";

export interface Props {
  dataLoaded: boolean;
  error: any;
}

// Data Loader will return null if Error exists for fetching API
function DataLoader({ dataLoaded, error }: Props) {
  if (!error) {
    const dataLoader = dataLoaded ? (
      <React.Fragment />
    ) : (
      <Dialog
        getApplicationNode={() => document.getElementById("fitlerPanels")}
        actions={[
          <button className="ds-c-button ds-c-button--primary" key="primary" />,
        ]}
      >
        Loading Data...
      </Dialog>
      //TODO: Change background image to proper image and text should be part of the component instead of image itself
    );
    return dataLoader;
  }
  return null;
}

export default DataLoader;
